import Local from "../util/common/local"

export const AdminStore = {
    state: {
        user: Local.getLocal("user", "object"),
        role: Local.getLocal("role", "object"),
        bindCompanies: Local.getLocal("bindCompanies", "object"),
        breadList: [
            {
                path: "/ahome",
                name: "首页",
                icon: "ios-home-outline",
                mname: "ahome"
            }
        ],
        menuing: { // 当前菜单项
            subList: [],
            name: null
        }
    },
    mutations: {
        editBread(state, parmas) { // 模块 后台p_admin 面包屑列表更新
            let data = state.breadList;
            for (let i = 0, length = data.length; i < length; i++) {
                if (data[i].name == parmas.name) {
                    data.splice(i, 1);
                    break;
                }
            }
            data.push(parmas);
        },
        delBread(state, name) { // 模块 后台p_admin 面包屑列表删除
            let data = state.breadList;
            let isBread = false;
            for (let i = 0, length = data.length; i < length; i++) {

                if (!isBread) {
                    if (data[i].mname == name) {
                        isBread = true;
                    }
                } else {
                    data.splice(i, length - i);
                    break;
                }
            }
        },
        editMenu(state, parmas) { // 模块 后台p_admin 当前下拉项更新
            if (parmas.subId) state.menuing.subList.push(parmas.subId);
            if (parmas.path) state.menuing.name = parmas.path;
        },
        localUpdata(state, parmas) { // 登录后的本地数据更新
            if (parmas.user) state.user = parmas.user;
            if (parmas.role) state.role = parmas.role;
            if (parmas.bindCompanies) state.bindCompanies = parmas.bindCompanies;
        }
    },
    actions: {

    },
    getters: {

    }
}